// Centralised date/time formatting for the Strategy Engine UI.
// All exact timestamps are pinned to IST (Asia/Kolkata) so a 14:32 IST value
// reads the same in every viewer's timezone — important for a trading product.

const IST = 'Asia/Kolkata';

const istDate = new Intl.DateTimeFormat('en-IN', {
  day: '2-digit', month: 'short', year: 'numeric', timeZone: IST,
});
const istClock = new Intl.DateTimeFormat('en-IN', {
  hour: '2-digit', minute: '2-digit', second: '2-digit', hour12: true, timeZone: IST,
});
const istShort = new Intl.DateTimeFormat('en-IN', {
  day: '2-digit', month: 'short', hour: '2-digit', minute: '2-digit', hour12: true, timeZone: IST,
});

const toDate = (value) => {
  if (!value) return null;
  const d = new Date(value);
  return Number.isNaN(d.getTime()) ? null : d;
};

// { date: "19 Jun 2026", clock: "02:34:01 pm IST" } or null
export function formatIST(value) {
  const d = toDate(value);
  if (!d) return null;
  return { date: istDate.format(d), clock: `${istClock.format(d)} IST` };
}

// "19 Jun 2026" or "—"
export function formatISTDate(value) {
  const d = toDate(value);
  return d ? istDate.format(d) : '—';
}

// "19 Jun 2026, 02:34:01 pm IST" or "—"
export function formatISTDateTime(value) {
  const f = formatIST(value);
  return f ? `${f.date}, ${f.clock}` : '—';
}

// Compact label for chart tooltips: "19 Jun, 02:34 pm" or "—"
export function formatISTShort(value) {
  const d = toDate(value);
  return d ? istShort.format(d) : '—';
}

// "Just now" / "5 min ago" / "3h ago" / "2d ago", else the IST date.
export function getRelativeTime(value) {
  const d = toDate(value);
  if (!d) return '—';
  const diffSec = Math.floor((Date.now() - d.getTime()) / 1000);
  const diffMin = Math.floor(diffSec / 60);
  const diffHour = Math.floor(diffMin / 60);
  const diffDay = Math.floor(diffHour / 24);
  if (diffSec < 60) return 'Just now';
  if (diffMin < 60) return `${diffMin} min ago`;
  if (diffHour < 24) return `${diffHour}h ago`;
  if (diffDay < 7) return `${diffDay}d ago`;
  return istDate.format(d);
}
